import React, { useState } from 'react'
import ManagementRecruitment from '../components/ManagementRecruitment/ManagementRecruitment'

const ManagementRecruitmentPage = () => {
  return (
    <>
      <ManagementRecruitment />
    </>
  )
}

export default ManagementRecruitmentPage
